import { api } from 'roboflex-thalamus-request-handler'
import serviceGoogleCalendar from './serviceGoogleCalendar'

export default {
    async listar(projetoId) {
        const response = await api.get(`projeto/${projetoId}/reunioes`)
        return response.data
    },

    async criar(projetoId, payload) {
        const response = await api.post(`projeto/${projetoId}/reunioes`, payload)
        return response.data
    },

    async excluir(projetoId, reuniaoId) {
        const response = await api.delete(`projeto/${projetoId}/reunioes/${reuniaoId}`)
        return response.data
    },

    async listarTarefasWeekly(projetoId, data) {
        const response = await api.get(`projeto/${projetoId}/reunioes/tarefas-weekly`, {
            params: { data },
        })
        return response.data?.data || []
    },

    async listarPacotesWeekly(projetoId, data) {
        const response = await api.get(`projeto/${projetoId}/reunioes/pacotes-weekly`, {
            params: { data },
        })
        return response.data?.data || []
    },

    async listarSalas(projetoId) {
        const response = await api.get(`projeto/${projetoId}/reunioes/salas`)
        return response.data?.data || []
    },

    async disponibilidade(projetoId, payload) {
        const response = await api.post(`projeto/${projetoId}/reunioes/disponibilidade`, payload)
        return response.data
    },

    async listarEnvolvidos(projetoId) {
        const response = await api.get(`projeto/${projetoId}/envolvidos`)
        return response.data?.data || []
    },

    async obterRedirectUrlGoogle(redirectTo = null) {
        return serviceGoogleCalendar.obterRedirectUrl(redirectTo)
    },

    async listarUsuarios() {
        const response = await api.get('google/calendar/usuarios')
        return response.data?.usuarios || []
    },

    async criarTarefa(reuniaoId, payload) {
        const response = await api.post(`google/calendar/reunioes/${reuniaoId}/tarefas`, payload)
        return response.data
    },

    async atualizarTarefa(reuniaoId, tarefaId, payload) {
        const response = await api.patch(`google/calendar/reunioes/${reuniaoId}/tarefas/${tarefaId}`, payload)
        return response.data
    },
}
